import React from 'react';
import '/client/app/styles/text.scss';

export default function SettingsView() {
	return <div />;
}
